import { IndicatorTypes, SelectTypes, TAggregatedBaseIndicators } from './common-aggregated';

import { TPageMetadataWithItems } from '@/types/meta';

export type TForeignTradeByProductsFilter = {
  periods: string[];
  regionsRf: string[];
  countries: string[];
  tradeDirectionId: number;
  selectTypeId: SelectTypes;
  amountSigns: number;
  indicatorTypeId: IndicatorTypes;
};

export type TForeignTradeByProductsTableData = TPageMetadataWithItems<TForeignTradeByProductsItem> & {
  periods: string[];
};

export type TForeignTradeByProductsItem = {
  code: string | null;
  product: string;
  indicators: (TAggregatedBaseIndicators & {
    total: TAggregatedBaseIndicators;
  })[];
};

export enum ProductsTradeDirections {
  EXPORT = 1,
  IMPORT = 2,
  TURNOVER = 3,
}
